module.exports = __webpack_public_path__ + "images/file_icons_v2/ico-ed105dc23397f122bcc763a1af10df92.svg";